import React, { useRef, useState } from "react";
import "../Header/header.css";
import Container from "../Container/Index";
import Logo from '../Header/Logo/Index';
import Navbar from "../Header/Navbar/Index";
import useStickyHeader from "./useStickyHeader";
import { Link, useLocation } from "react-router-dom";
import FixedSticky from "../Sticky/FixedSticky";

const Header = ({ relativeHeader = "" }) => {
  const headerRef = useRef(null);
  useStickyHeader(headerRef);
  const location = useLocation();
  const isCurrentpage = location.pathname === '/outsource-your-bottling';

  const [menuData] = useState([
    { name: "Home", link: "/" },
    { name: "About Us", link: '/about-united-corp' },
    { 
      name: "Our Services", 
      link: '/our-services',
      submenus: [
        {
          text: "Office Stationery & Supplies",
          link: "/our-services/office-stationery-supplies",
        },
        {
          text: "Corporate Gifting Solution",
          link: "/our-services/corporate-gifting-solution",
        },
        {
          text: "Custom Packaging Solutions",
          link: "/our-services/custom-packaging-solutions",
        }
      ]
    },
    { name: "Our clients", link: '/our-clients' },
    { name: "Contact Us", link: '/contact-us' }
  ]);

  return (
   <>
    <header className='col-12 float-start d-lg-flex align-items-center'>
      <Container _parentClass={`header header-border top-0 ${relativeHeader}`} ref={headerRef}>
        <div className='row align-items-center m-0'>
          {/* Updated mobile column sizes for better logo visibility */}
          <div className="col-lg-3 col-8 logo-container">
            <div
              className="logo"
              data-aos="zoom-in"
              data-aos-offset="100"
              data-aos-duration="500"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              <Link to="/">
                <Logo />
              </Link>
            </div>
          </div>
          <div className="col-lg-9 col-4 navbar-container">
            <Navbar menuData={menuData} />
          </div>
        </div>
      </Container>
    </header>
    {/* {!isCurrentpage && <FixedSticky />} */}
   </>
  );
};

export default Header;